const STAFF_ROLES = ['Staff', 'Reporting Manager', 'ReportingManager', 'Manager'];

export const isStaffLikeRole = (user) => {
  const role = user?.role;
  return STAFF_ROLES.includes(role) || Boolean(user?.is_reporting_manager);
};

export const getAuthenticatedLandingPath = (user) => {
  const role = user?.role;

  if (isStaffLikeRole(user)) return '/staff/dashboard';
  if (role === 'CRM Officer' || role === 'CRM Associate') return '/crm';
  if (role === 'ExlvaAdminLite') return '/training';
  if (role === 'Super Admin' || role === 'Exlva Admin' || role === 'ExlvaAdmin' || role === 'Admin') return '/super-admin';
  return '/dashboard';
};

export const isAuthenticatedAppPath = (pathname = '') => {
  return [
    '/dashboard',
    '/staff',
    '/manager',
    '/crm',
    '/training',
    '/hospital',
    '/super-admin',
    '/hospitals',
    '/view-hospital',
    '/profile',
    '/subscription',
    '/subscriptions',
    '/assessments',
    '/feedback',
    '/evaluations',
    '/admin',
  ].some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
};

export const rememberAuthenticatedPath = (pathname, search = '') => {
  if (isAuthenticatedAppPath(pathname)) {
    localStorage.setItem('last_authenticated_path', `${pathname}${search || ''}`);
  }
};

export const getSessionReturnPath = (user) => {
  const savedPath = localStorage.getItem('last_authenticated_path');
  if (savedPath && isAuthenticatedAppPath(savedPath.split('?')[0])) {
    return savedPath;
  }
  return getAuthenticatedLandingPath(user);
};

export const restoreStoredSession = async () => {
  let token = localStorage.getItem('token');
  if (!token) return null;

  const fetchCurrentUser = async (currentToken) => {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/me`, {
      headers: { Authorization: `Bearer ${currentToken}` },
    });
    if (!response.ok) return { ok: false, status: response.status };
    return { ok: true, user: await response.json() };
  };

  let result = await fetchCurrentUser(token);

  if (!result.ok && result.status === 401) {
    const refreshResponse = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/refresh-token`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
    });
    if (refreshResponse.ok) {
      const refreshData = await refreshResponse.json();
      if (refreshData.token) {
        token = refreshData.token;
        localStorage.setItem('token', token);
        result = await fetchCurrentUser(token);
      }
    }
  }

  if (!result.ok || !result.user) return null;

  localStorage.setItem('user', JSON.stringify(result.user));
  return result.user;
};
